module.exports = __webpack_public_path__ + "static/media/focus-style-layout.47d600d2.png";